import { useEffect, useState, useRef, memo, useContext, ReactNode, Fragment } from 'react';
import {createMarkup} from 'bodycodi/cmap/app/js/common.js';
import {createPortal} from 'react-dom';
import {StateContext, DispatchContext} from 'bodycodi/cmap/app/components/common/context';

const ToastWrap = () => {
    const body: HTMLBodyElement | null = document.querySelector('body')!;
    return createPortal(
        <Toast/>,
        body
    );
}

const Toast = () => {
    
    const {state} = useContext(StateContext);
    const {dispatch} = useContext(DispatchContext);
    const [open, setOpen] = useState<boolean>(false);
    const [timer, setTimer] = useState<any>();
    const [timer1, setTimer1] = useState<any>();
    const toast = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if(state.toast){
            setOpen(true);
            setTimer1(setTimeout(() => {closeToast()}, 2000));
        }else{
            toast.current?.classList.add("close");
            setTimer(setTimeout(() => {setOpen(false); closeToast()}, 1000));
        }
    }, [state.toast]);
    
    const closeToast = () => {
        dispatch({type: "UPDATE", data: {toast: false}});
    }

    return(
        <Fragment>
            {open && (
                <div className="toast"  ref={toast} dangerouslySetInnerHTML={{__html: createMarkup(state.toastText).__html}}>
                    
                </div>
            )}
        </Fragment>
        
    )
}

export const ToastFull = () => {
    
    const {state} = useContext(StateContext);
    const {dispatch} = useContext(DispatchContext);
    const [open, setOpen] = useState<boolean>(false);
    const [timer, setTimer] = useState<any>();
    const [timer1, setTimer1] = useState<any>();
    const toast = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if(state.toast1){
            setOpen(true);
            setTimer1(setTimeout(() => {closeToast()}, 2000));
        }else{
            toast.current?.classList.add("close");
            setTimer(setTimeout(() => {setOpen(false); closeToast()}, 1000));
        }
    }, [state.toast1]);
    
    const closeToast = () => {
        dispatch({type: "UPDATE", data: {toast1: false}});
    }

    return(
        <Fragment>
            {open && (
                <div className="toast full"  ref={toast} dangerouslySetInnerHTML={{__html: createMarkup(state.toastText).__html}}>
                    
                </div>
            )}
        </Fragment>
        
    )
}

/*<span className="white">{state.toastText.highlight}</span>{state.toastText.text}*/
export default ToastWrap;